module.exports = __webpack_public_path__ + "static/media/blogs_image.630a2bf3.svg";